<template>
    <router-view v-if="$route && $route.meta && $route.meta.updateOnUrl" :key="$route.fullPath" :props="props"></router-view>
    <router-view v-else :props="props"></router-view>
</template>
<script>
export default {
    props: [
        'props'
    ],
    created() {
        // console.log('router', this.$router)
        // console.log('route', this.$route)
    }
}
</script>





// WEBPACK FOOTER //
// resources/js/components/Layouts/DefaultLayout.vue